import React, { MutableRefObject, PureComponent } from 'react';
import { connect, MapDispatchToProps, MapStateToProps } from 'react-redux';
import {
  requireDocument,
  requireDocumentFn,
  requireDocumentInFolder,
  requireDocumentInFolderFn,
  requireProvider,
  requireProviderFn,
} from 'store/providers/providerSlice';
import notify from '../../../../components/Notify';
import LoadingCircleIndicator from '../../../../components/LoadingCircleIndicator/LoadingCircleIndicator';
import Button from '../../../../components/Button/Button';
import {
  Back,
  BackContainer,
  BadgeContainer,
  BadgeImage,
  BoxHeader,
  CardHeader,
  CardHeaderText,
  ChartContainer,
  ChatBotButton,
  ChatBotContainer,
  ChatBotHeader,
  ChatBotLogo,
  ChatBotQuestion,
  ChatBotSubHeader,
  ChatSendIcon,
  ColumnRowContainer,
  ContentBox,
  ContentContainer,
  ContentRow,
  EmptyPlaceHolder,
  // Filled,
  Header,
  HeaderContent,
  HeaderLogo,
  Item,
  ItemImage,
  ItemName,
  LGHorizontalCell,
  LGNormalCell,
  MDCell,
  More,
  RowContainer,
  SectionContainer,
  XLGNormalCell,
  XLGVerticalCell,
} from './styles';
import { Link, navigate } from '@reach/router';
import { isImage, itemIconSelector } from '../../../../utils/fileUtils';
import { distance } from '../../../../utils/happyFunctions';
import { black } from '../../../../utils/style/colors';
import { getDomainAndPort } from '../../../../api/Utils';
import Icon from '../../../../components/Icon/Icon';
import { appDispatch, RootState } from 'store/store';
import {
  getDateOf,
  IProvider,
  IProviderItemView,
  IProviderLinkView,
} from 'store/providers/providerTypes';
import { IProviderSurveyReport } from 'store/survey/surveyTypes';
import LocalIcon from '../../../../ui/LocalIcon';
import { Settings } from 'react-slick';
import i18n, { languageDirection } from '../../../../i18n';
import ChartViewer from '../../../../components/Chart/ChartViewer';
import Stories from 'react-insta-stories';
import { Flipped } from 'react-flip-toolkit';
import Typewriter from 'typewriter-effect';
import messages from './messages';
import SanitizedHTML from 'react-sanitized-html';
import { pxToRem } from '../../../../utils/chatbot/convertSize';
import {
  IconColorFinder,
  IconLogoFinder,
} from '../../../../utils/check-file-type/findIconViaType';
import { summerizeText } from '../../../../utils/summerizeText';
import Marquee from 'components/Marquee/Marquee';
import ExpandableText from './ExpandableText';
import { useSelector } from 'react-redux';
import ItemsSlider from './ItemsSlider';
import ItemsTinderStack from './ItemsTinderStack';

interface IDispatchToProps {
  requireProviderItem: (id: number) => ReturnType<typeof requireDocumentFn>;
  requireDocumentInFolder: (
    id: number
  ) => ReturnType<typeof requireDocumentInFolderFn>;
  requireProvider: (id: number) => ReturnType<typeof requireProviderFn>;
}

interface IComponentStates {
  loading: boolean;
  folderLoading: boolean;
  itemsLoaded: boolean;
  width: number;
  pos?: { lat: number; long: number };
  storyOpen?: number;
}
interface IOwnProps {
  folderId?: number;
  providerId: number;
  directItems?: IProviderItemView[];
  title?: string;
  onOpen: (item: IProviderItemView) => void;
  provider: IProvider | null;
  showImage?: boolean;
  grid?: boolean;
  shine?: boolean;
  itemArrangement?: Array<{ id: number; order: number }>;
  onResetItemArrangement?: () => void;
  onSelectItemForItemManagement?: (item: { id: number }) => void;
  onSelectedItem?: (id: number | null) => void;
  displayMode: 'text' | 'sm' | 'md' | 'lg' | 'xlg' | 'slider' | 'tinder';
  folderShowBack: boolean;
  selectedMoreId: number | null;
  itemFolder?: number;
}

interface IStateToProps {
  folder?: IProviderItemView;
  items?: IProviderItemView[];
  loadedProviderIds?: number[];
  isLight: boolean;
}

type IComponentProps = IDispatchToProps & IStateToProps & IOwnProps;

/*function getItemIcon(item: IProviderItemView) {
  if (item.type == 'link') {
    return 'user';
  }
  if (item.type == 'survey') {
    return 'check-square';
  }
  if (item.type == 'folder') {
    return 'folder';
  }
  if (item.type == 'quill') {
    return 'folder';
  }
}*/

interface ICellSelector {
  displayMode: 'md' | 'lg' | 'xlg';
  cellType: 'md' | 'lg';
  children: React.ReactNode;
  onClick: (e: any) => void;
  isChatbot: boolean;
}

export const CellSelector: React.FC<ICellSelector> = ({
  displayMode,
  cellType,
  children,
  onClick,
  isChatbot,
}) => {
  const isLightMode = useSelector(
    (state: RootState) => state.app.UI.webdaThemeMode === 'light'
  );

  return displayMode === 'xlg' ? (
    cellType === 'lg' ? (
      <XLGVerticalCell
        onClick={onClick}
        isChatbot={isChatbot}
        isDarkMode={!isLightMode}
      >
        {children}
      </XLGVerticalCell>
    ) : (
      <XLGNormalCell
        onClick={onClick}
        isChatbot={isChatbot}
        isDarkMode={!isLightMode}
      >
        {children}
      </XLGNormalCell>
    )
  ) : displayMode === 'lg' ? (
    cellType === 'lg' ? (
      <LGHorizontalCell
        onClick={onClick}
        isChatbot={isChatbot}
        isDarkMode={!isLightMode}
      >
        {children}
      </LGHorizontalCell>
    ) : (
      <LGNormalCell
        onClick={onClick}
        isChatbot={isChatbot}
        isDarkMode={!isLightMode}
      >
        {children}
      </LGNormalCell>
    )
  ) : (
    <MDCell onClick={onClick} isChatbot={isChatbot} isDarkMode={!isLightMode}>
      {children}
    </MDCell>
  );
};

class HorizentalFolderView extends PureComponent<
  IComponentProps,
  IComponentStates
> {
  private fetchProviderIdRef: MutableRefObject<boolean>;
  constructor(props: IComponentProps) {
    super(props);
    this.fetchProviderIdRef = { current: false };
  }
  state: IComponentStates = {
    loading: false,
    folderLoading: false,
    itemsLoaded: false,
    width: window.innerWidth,
    storyOpen: 0,
  };

  settings: Settings = {
    dots: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: false,
    rtl: languageDirection() === 'rtl',
  };

  resizePage = () => {
    this.setState({ width: window.innerWidth });
  };

  componentDidMount(): void {
    this.componentDidUpdate();
    if (getDomainAndPort().domainFeatures?.checkForDistance) {
      window.navigator.geolocation.getCurrentPosition((pos) => {
        if (pos.coords.accuracy < 1000) {
          this.setState({
            pos: { long: pos.coords.longitude, lat: pos.coords.latitude },
          });
        }
      });
    }
    window.addEventListener('resize', this.resizePage);
  }

  componentDidUpdate(prevProps?: Readonly<IComponentProps>): void {
    if (this.props.directItems) return;
    if (
      !this.props.folder ||
      !prevProps ||
      prevProps.folderId !== this.props.folderId
    ) {
      if (!this.props.folder) {
        this.loadFolderItSelf();
      }
      this.loadFolderContent();
    }
    if (this.props.directItems) {
      this.setState({ itemsLoaded: true });
    }
    if (!prevProps || prevProps!.folderId !== this.props.folderId) {
      this.setState({ itemsLoaded: false });
    }

    if (!this.fetchProviderIdRef.current) {
      (this.props.directItems || this.props.items)?.map((item) => {
        if (
          item.tags.some(
            (el) =>
              el.text === 'conf_openChat' &&
              !this.props.loadedProviderIds?.includes(
                item.linkedProviderId as number
              )
          )
        ) {
          this.props.requireProvider(item.linkedProviderId as number);
          this.fetchProviderIdRef.current = true;
        }
      });
    }
  }

  loadFolderItSelf = () => {
    this.setState({ folderLoading: true });
    this.props.requireProviderItem(Number(this.props.folderId)).then(
      () => {
        this.setState({ folderLoading: false });
      },
      () => {
        this.setState({ folderLoading: false });
        notify(
          i18n.t('networkError', { ns: 'landingPage' }) as string,
          'error'
        );
      }
    );
  };

  loadFolderContent = () => {
    if (this.state.itemsLoaded) return;
    this.setState({ loading: true });
    this.props
      .requireDocumentInFolder(Number(this.props.folderId))
      .then(() => {
        this.setState({ loading: false, itemsLoaded: true });
      })
      .catch(() => {
        notify(
          i18n.t('networkError', { ns: 'landingPage' }) as string,
          'error'
        );
        this.setState({ loading: false });
      });
  };

  getName = (item: IProviderItemView) => {
    if (item.name) return item.name;
    if (item.type === 'link') return (item as any).providerName;
  };

  chunkArray(arr: any, size: number = 3) {
    const result = [];
    for (let i = 0; i < arr.length; i += size) {
      result.push(arr.slice(i, i + size));
    }

    return result;
  }

  customHeader = ({
    profileImage,
    heading,
  }: {
    profileImage: string;
    heading: string;
  }) => (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        top: '10px',
        left: '10px',
        background: 'rgba(0,0,0,0.5)',
        color: 'white',
        padding: '10px',
        borderRadius: '10px',
        width: 'calc(100vw - 20px)',
      }}
    >
      <img
        src={profileImage}
        alt="Profile"
        style={{
          width: '40px',
          height: '40px',
          borderRadius: '50%',
          marginInlineEnd: '10px',
        }}
      />
      <span style={{ fontWeight: 'bold' }}>{heading}</span>
      <div style={{ flex: 1 }}></div>
    </div>
  );

  ItemCalculator = (
    items: IProviderItemView[],
    isLgXlg = true,
    displayMode: 'xlg' | 'lg' | 'md',
    isShine = false
  ): IProviderItemView[] => {
    const counter = displayMode === 'lg' && isShine ? 8 : 4;
    if (isLgXlg) {
      return items.reduce(
        (
          acc: { counter: number; itemList: IProviderItemView[] },
          currentValue: IProviderItemView
        ) => {
          const isLgCell =
            currentValue.viewType?.split(',')?.includes('card_lg') ||
            (currentValue.type === 'link' &&
              currentValue.tags.some((tag) => tag.text === 'conf_openChat') &&
              displayMode === 'lg');

          const cellSize = isLgCell ? 2 : 1;

          if (acc.counter + cellSize > counter) {
            return acc;
          }

          return {
            counter: acc.counter + cellSize,
            itemList: [...acc.itemList, currentValue],
          };
        },
        { counter: 0, itemList: [] }
      ).itemList;
    } else {
      return items.slice(0, 6);
    }
  };

  CalcChunkSizeBaseonType = (documentHolderWidth: number): number => {
    // if (this.props.grid) return 100;
    return documentHolderWidth <= 3
      ? 3
      : documentHolderWidth === 4
        ? 4
        : documentHolderWidth === 5
          ? 6
          : 6;
  };

  render() {
    const {
      itemFolder,
      folder,
      items,
      directItems,
      title,
      grid,
      shine,
      onResetItemArrangement,
      itemArrangement,
      onSelectItemForItemManagement,
      displayMode,
      selectedMoreId,
      isLight,
    } = this.props;
    const { loading, folderLoading, itemsLoaded, pos, width } = this.state;
    let mobileSize = 'M';
    let desktopSize = 'M';
    let orderByDistance = false;
    const showStory = true;
    folder?.tags?.forEach((t) => {
      if (t.text.startsWith('SIZE_M_')) mobileSize = t.text.substring(7);
      else if (t.text.startsWith('SIZE_D_')) desktopSize = t.text.substring(7);
      else if (t.text.startsWith('SIZE_'))
        desktopSize = mobileSize = t.text.substring(7);
      if (t.text === 'ORDER_BY_DISTANCE') {
        orderByDistance = true;
      }
    });

    const finalItems = (directItems || items)?.sort((a, b) => {
      if (orderByDistance && pos) {
        return (
          distance(
            pos.long,
            pos.lat,
            (a as any).address?.longitude ?? 0,
            (a as any).address?.latitude ?? 0
          ) -
          distance(
            pos.long,
            pos.lat,
            (b as any).address?.longitude ?? 0,
            (b as any).address?.latitude ?? 0
          )
        );
      }
      return a.order - b.order;
    });
    const finalTitle = (folder?.formatedName || title || folder?.name)?.trim();

    const documentHolderWidth = Math.ceil(pxToRem(width) / 18);

    const chunkedData =
      finalItems?.filter(
        (a) =>
          !a.tags.some(
            (tag) =>
              tag.text.toLowerCase() === 'conf_hidden' ||
              tag.text.toLowerCase() === 'conf_header'
          )
      ) || [];

    const getOnClick = (el: IProviderItemView) => {
      const multiTypeModal = ['document', 'file', 'quill'];
      return (e: React.MouseEvent) => {
        e.preventDefault();
        e.stopPropagation();
        if (el.tags.some((tag) => tag.text === 'conf_openChat')) {
          navigate(`/${el.linkedProviderId}/#chat`);
        } else if (multiTypeModal.includes(el.type)) {
          const params = new URLSearchParams(location.search);
          params.set('modal', `${el.id}`);
          navigate(`${location.pathname}?${params.toString()}`);
          this.props.onSelectedItem?.(el.id as number);
        } else {
          this.props.onOpen(el);
        }
      };
    };

    const isPreview = !selectedMoreId;
    const hideTitle =
      shine || !!folder?.tags?.find((it) => it.text === 'conf_hideTitle');
    const showBack =
      selectedMoreId &&
      itemArrangement?.length === 1 &&
      itemArrangement[0].id === (folder?.id || itemFolder);
    return directItems || folder ? (
      <SectionContainer shine={this.props.shine}>
        {showStory && !!this.state.storyOpen && (
          <div
            style={{
              position: 'absolute',
              top: 0,
              right: 0,
              width: '100vw',
              height: '100vh',
              zIndex: 100,
            }}
          >
            {(() => {
              const stories =
                finalItems
                  ?.filter(
                    (item) =>
                      item.type === 'document' &&
                      item.document &&
                      isImage(item.document!.properties.format)
                  )
                  ?.map((item) => {
                    return {
                      url: item.document!.url,
                      header: {
                        heading: item.name || '',
                        profileImage: item.thumbnailUrl,
                        subheading: '',
                      },
                      id: item.id,
                    };
                  }) || [];
              return (
                <Stories
                  stories={stories}
                  currentIndex={stories.findIndex(
                    (it) => it.id === this.state.storyOpen
                  )}
                  defaultInterval={5000}
                  width="100vw"
                  height="100vh"
                  progressWrapperStyles={{ transform: 'scaleX(-1)' }}
                  header={this.customHeader}
                  onAllStoriesEnd={() => this.setState({ storyOpen: 0 })}
                  storyStyles={{
                    width: '100vw',
                    height: '100vh',
                    objectFit: 'contain', // Adjust this to "contain" if needed
                    justifyContent: 'center',
                  }}
                />
              );
            })()}
            <Button
              style={{
                position: 'absolute',
                top: '30px',
                left: '30px',
                background: 'rgba(0,0,0,0.5)',
                border: 'none',
                padding: '10px',
                cursor: 'pointer',
                borderRadius: '50%',
                zIndex: 1000,
                pointerEvents: 'auto',
                color: 'white',
              }}
              onClick={(e) => {
                e.stopPropagation(); // Prevent Stories from capturing the click
                this.setState({ storyOpen: 0 });
              }}
            >
              {
                i18n.t('close', {
                  ns: 'documentManager',
                }) as string
              }
            </Button>
          </div>
        )}
        {loading ? (
          <LoadingCircleIndicator />
        ) : finalItems && finalItems.length ? (
          finalItems.length === 1 && finalItems[0].type === 'surveyReport' ? (
            (() => {
              const providerId = finalItems[0].providerId;
              return (
                <Flipped key={folder?.id} flipId={folder?.id}>
                  <ContentBox id={finalItems[0].id}>
                    <BoxHeader showBack={showBack}>
                      <Header showBack={showBack}>
                        {finalTitle && !hideTitle && finalItems ? (
                          <CardHeader id={'i' + (folder?.id || 'rest')}>
                            <CardHeaderText>
                              <HeaderContent>
                                <SanitizedHTML
                                  allowedAttributes={{ span: ['style'] }}
                                  html={finalTitle}
                                />
                              </HeaderContent>
                            </CardHeaderText>
                          </CardHeader>
                        ) : (
                          <></>
                        )}
                      </Header>
                    </BoxHeader>
                    <ChartContainer>
                      <ChartViewer
                        key={`${folder?.id + 'report'}`}
                        reportItem={{
                          item: {
                            data: finalItems[0],
                            isLoading: false,
                          },
                          status: 'view',
                        }}
                        autoLoad={true}
                        viewType={'Dashboard'}
                        baseDate={getDateOf(
                          (finalItems[0] as IProviderSurveyReport)
                            .defaultEndTime || 'Today'
                        ).toDate()}
                        embedded={true}
                        dataContext={{ providerId: providerId }}
                        simple={true}
                      />
                    </ChartContainer>
                  </ContentBox>
                </Flipped>
              );
            })()
          ) : displayMode === 'text' ? (
            <ExpandableText items={finalItems} />
          ) : displayMode === 'slider' ? (
            <ItemsSlider title={finalTitle} items={finalItems} />
          ) : displayMode === 'tinder' ? (
            <ItemsTinderStack title={finalTitle} items={finalItems} />
          ) : (
            <Flipped
              key={folder?.id}
              flipId={folder?.id}
              shouldFlip={() => false}
            >
              <ContentBox id={folder?.id}>
                {showBack && (
                  <BackContainer>
                    <Back
                      showBack={showBack}
                      onClick={() => onResetItemArrangement?.()}
                    >
                      <Icon
                        type={
                          languageDirection() === 'rtl'
                            ? 'arrow-right'
                            : 'arrow-left'
                        }
                        style={{ marginLeft: '5px' }}
                        color={black}
                      />
                      {i18n.t('back', { ns: 'landingPage' }) as string}
                    </Back>
                  </BackContainer>
                )}
                <BoxHeader showBack={showBack}>
                  {folder?.thumbnailUrl && !hideTitle && (
                    <HeaderLogo src={`${folder?.thumbnailUrl}`} />
                  )}
                  <Header showBack={showBack}>
                    {finalTitle && !hideTitle && finalItems ? (
                      <CardHeader id={'i' + (folder?.id || 'rest')}>
                        <CardHeaderText showBack={showBack}>
                          <HeaderContent>
                            <SanitizedHTML
                              allowedAttributes={{ span: ['style'] }}
                              html={finalTitle}
                            />
                          </HeaderContent>
                        </CardHeaderText>
                      </CardHeader>
                    ) : (
                      <></>
                    )}
                  </Header>
                </BoxHeader>
                {displayMode === 'sm' ? (
                  <ColumnRowContainer
                    direction={documentHolderWidth <= 3 ? 'column' : 'row'}
                  >
                    {(isPreview
                      ? chunkedData.slice(
                          0,
                          this.CalcChunkSizeBaseonType(documentHolderWidth)
                        )
                      : chunkedData
                    ).map((el: IProviderItemView) => (
                      <RowContainer
                        key={el.id}
                        onClick={getOnClick.call(this, el)}
                      >
                        <BadgeContainer color={IconColorFinder(el.type)}>
                          {el.thumbnailUrl ? (
                            <BadgeImage src={`${el.thumbnailUrl}`} />
                          ) : (
                            <LocalIcon
                              iconName={IconLogoFinder({
                                type: el.type,
                                format: el.document?.properties?.format,
                              })}
                              color={black}
                              type="sm"
                            />
                          )}
                        </BadgeContainer>
                        <ContentContainer
                          {...this.settings}
                          infinite={chunkedData.length > 1}
                        >
                          {this.state.width < 600 ? (
                            summerizeText(this.getName(el) ?? '', 25)
                          ) : (
                            <Marquee text={this.getName(el) ?? ''} />
                          )}
                        </ContentContainer>
                      </RowContainer>
                    ))}
                  </ColumnRowContainer>
                ) : (
                  <ContentRow
                    displayMode={displayMode}
                    isShine={shine}
                    isPreview={isPreview}
                  >
                    {(isPreview
                      ? this.ItemCalculator(
                          chunkedData,
                          ['lg', 'xlg'].includes(displayMode),
                          displayMode,
                          shine
                        )
                      : chunkedData
                    ).map((item, index) => {
                      const thumb = item.thumbnailUrl;
                      const round = false;
                      const itemId = item.id;
                      const isLgCard = item.viewType
                        ?.split(',')
                        ?.includes('card_lg');
                      const cellType =
                        isLgCard ||
                        (item.type === 'link' &&
                          item.tags.find(
                            (tag) => tag.text === 'conf_openChat'
                          ) &&
                          displayMode === 'lg')
                          ? 'lg'
                          : 'md';
                      // const surveyItem =
                      //   item.type === 'survey'
                      //     ? (item as ISurveyItem)
                      //     : undefined;
                      return (
                        <CellSelector
                          displayMode={displayMode}
                          cellType={cellType}
                          key={index}
                          onClick={getOnClick.call(this, item)}
                          isChatbot={Boolean(
                            item.tags.find(
                              (tag) => tag.text === 'conf_openChat'
                            )
                          )}
                        >
                          <Item
                            className="glass-card"
                            as={Link as any}
                            to={'.'}
                            key={itemId}
                            onClick={getOnClick.call(this, item)}
                            grid={!!grid}
                            mobileSize={
                              item.tags.some(
                                (tag) => tag.text === 'conf_openChat'
                              )
                                ? 'MB'
                                : mobileSize
                            }
                            desktopSize={desktopSize}
                            shine={shine}
                            background={shine ? 'transparent' : undefined}
                            displayMode={displayMode}
                            cellType={cellType}
                          >
                            {item.type === 'link' &&
                            item.tags.find(
                              (tag) => tag.text === 'conf_openChat'
                            ) ? (
                              <>
                                <ChatBotContainer>
                                  <ChatBotLogo src={`${item.thumbnailUrl}`} />
                                  <ChatBotHeader>
                                    {this.getName(item)}
                                  </ChatBotHeader>
                                  <ChatBotSubHeader>
                                    {messages.AI}
                                  </ChatBotSubHeader>
                                  <ChatBotButton>
                                    <ChatBotQuestion>
                                      <Typewriter
                                        options={{
                                          strings: (item as IProviderLinkView)
                                            .botIntegrationProperties
                                            ?.defaultPrompts,
                                          delay: 35,
                                          autoStart: true,
                                          loop: true,
                                          // pauseFor: 2000,
                                          deleteSpeed: 50,
                                        }}
                                      />
                                    </ChatBotQuestion>
                                    <ChatSendIcon>
                                      <LocalIcon
                                        iconName={'arrow-top.svg'}
                                        style={{ margin: '0.25rem auto' }}
                                      />
                                    </ChatSendIcon>
                                  </ChatBotButton>
                                </ChatBotContainer>
                              </>
                            ) : (
                              <>
                                <ItemImage
                                  src={thumb || itemIconSelector(item, isLight)}
                                  poster={!!thumb && !shine}
                                  round={round}
                                  mobileSize={mobileSize}
                                  desktopSize={desktopSize}
                                  background={'rgba(1,1,1,0)'}
                                  shine={shine}
                                  displayMode={displayMode}
                                  cellType={cellType}
                                />
                                {/* {(surveyItem?.myResponseInfo?.filledPeriods
                                  .length || 0) > 0 && (
                                  <Filled
                                    mobileSize={mobileSize}
                                    desktopSize={desktopSize}
                                  >
                                    <span>
                                      {
                                        i18n.t(
                                          `${
                                            surveyItem!.myResponseInfo
                                              .filledPeriods[0] ||
                                            surveyItem!.myResponseInfo
                                              .filledPeriods[0]
                                          }`,
                                          { ns: 'landingPage' }
                                        ) as string
                                      }
                                    </span>
                                    <Icon type="check" color={exactWhite} />
                                  </Filled>
                                )} */}
                                <ItemName
                                  mobileSize={mobileSize}
                                  desktopSize={desktopSize}
                                  displayMode={displayMode}
                                  cellType={cellType}
                                >
                                  {this.state.width > 600 &&
                                  displayMode === 'md' ? (
                                    <Marquee text={this.getName(item)} />
                                  ) : (
                                    this.getName(item)
                                  )}
                                </ItemName>
                              </>
                            )}
                          </Item>
                        </CellSelector>
                      );
                    })}
                  </ContentRow>
                )}
                {isPreview &&
                (displayMode === 'sm'
                  ? this.CalcChunkSizeBaseonType(documentHolderWidth) <
                    chunkedData.length
                  : this.ItemCalculator(
                      chunkedData,
                      ['lg', 'xlg'].includes(displayMode),
                      displayMode,
                      shine
                    ).length < chunkedData.length) ? (
                  <More
                    showBack={showBack}
                    onClick={() =>
                      onSelectItemForItemManagement?.({
                        id: (folder?.id || itemFolder) as number,
                      })
                    }
                  >
                    {i18n.t('more', { ns: 'landingPage' })}
                    <Icon type="arrow-left" color={black} />
                  </More>
                ) : (
                  <></>
                )}
              </ContentBox>
            </Flipped>
          )
        ) : itemsLoaded ? (
          <div>
            <ContentBox>
              <BoxHeader
                showBack={
                  itemArrangement?.length === 1 &&
                  itemArrangement[0].id === folder?.id
                }
              >
                {folder?.thumbnailUrl && (
                  <HeaderLogo src={`${folder?.thumbnailUrl}`} />
                )}
                <Header
                  showBack={
                    itemArrangement?.length === 1 &&
                    itemArrangement[0].id === folder?.id
                  }
                >
                  <HeaderContent>
                    <SanitizedHTML
                      allowedAttributes={{ span: ['style'] }}
                      html={finalTitle}
                    />
                  </HeaderContent>
                </Header>
              </BoxHeader>
              <EmptyPlaceHolder>
                {
                  i18n.t('noMatchFound', {
                    ns: 'landingPage',
                  }) as string
                }
              </EmptyPlaceHolder>
            </ContentBox>
          </div>
        ) : (
          <div>
            <p>
              {
                i18n.t('networkError', {
                  ns: 'landingPage',
                }) as string
              }
            </p>
            <Button onClick={this.loadFolderContent}>
              {i18n.t('tryAgain', { ns: 'landingPage' }) as string}{' '}
            </Button>
          </div>
        )}
      </SectionContainer>
    ) : folderLoading ? (
      <LoadingCircleIndicator />
    ) : (
      <div>
        <p>{i18n.t('networkError', { ns: 'landingPage' }) as string}3 </p>
        <Button onClick={this.loadFolderItSelf}>
          {i18n.t('tryAgain', { ns: 'landingPage' }) as string}{' '}
        </Button>
      </div>
    );
  }
}

const mapStateToProps: MapStateToProps<IStateToProps, IOwnProps, RootState> = (
  state,
  props
) => {
  const allItems = state.providers.items[Number(props.providerId)].items;
  const virtualChildren = allItems[props.folderId!]?.data?.virtualChildren;
  const items = Object.values(allItems).reduce(
    (ret: IProviderItemView[], item) => {
      if (
        item.data.dadId === props.folderId ||
        item.data.referenced?.find(
          (link: any) => link.sourceItemId === props.folderId
        ) ||
        (virtualChildren &&
          Array.isArray(virtualChildren) &&
          virtualChildren.includes(item.data.id))
      )
        ret.push(item.data);
      return ret;
    },
    [] as IProviderItemView[]
  );
  const folder = props.folderId ? allItems[props.folderId].data : undefined;
  const loadedProviderIds = Object.keys(state.providers.items).map((item) =>
    Number(item)
  );
  const isLight = state.app.UI.webdaThemeMode === 'light';
  return { items: items, folder, loadedProviderIds, isLight };
};

const mapDispatchToProps: MapDispatchToProps<IDispatchToProps, IOwnProps> = (
  _,
  props
) => {
  return {
    requireProviderItem: (id: number) =>
      appDispatch(requireDocument({ documentId: id })),
    requireDocumentInFolder: (id: number) =>
      appDispatch(
        requireDocumentInFolder({ folderId: id, providerId: props.providerId })
      ),
    requireProvider: (id: number) =>
      appDispatch(requireProvider({ providerId: id })),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(HorizentalFolderView);
